<template>
  <div class="PrivateViewingSlideSwitch flex flex-col flex-1" :style="cssVars">
    <TitleSlide
      v-if="activeSlide && activeSlide.id === 'title'"
      v-bind:title="privateViewing.title"
      v-bind:copy="`For ${privateViewing.clientName}`"
      v-bind:onClick="onToggle"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
    <TextSlide
      v-else-if="
        !!activeSlide &&
        !!activeSlide.block &&
        activeSlide.block.type === 'text_block'
      "
      v-bind:data="activeSlide.block.data"
      v-bind:isPlaying="isPlaying"
      v-bind:onClick="onToggle"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
    <MobileImageSlide
      v-else-if="
        $mq === 'mobile' &&
        activeSlide &&
        activeSlide.block &&
        (activeSlide.block.type === 'single_column_block' ||
          activeSlide.block.type === 'double_column_block' ||
          activeSlide.block.type === 'triple_column_block')
      "
      v-bind:columnNumber="columnNumber"
      v-bind:data="activeSlide.block.data"
      v-bind:isPlaying="isPlaying"
      v-bind:onClick="onToggle"
      v-bind:type="activeSlide.block.type"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
    <ImageSlide
      v-else-if="
        activeSlide &&
        activeSlide.block &&
        activeSlide.block.type === 'single_column_block'
      "
      v-bind:type="activeSlide.block.type"
      v-bind:data="activeSlide.block.data"
      v-bind:isPlaying="isPlaying"
      v-bind:onClick="onToggle"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
    <DoubleImageSlide
      v-else-if="
        activeSlide &&
        activeSlide.block &&
        activeSlide.block.type === 'double_column_block'
      "
      v-bind:type="activeSlide.block.type"
      v-bind:data="activeSlide.block.data"
      v-bind:isPlaying="isPlaying"
      v-bind:onClick="onToggle"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
    <TripleImageSlide
      v-else-if="
        activeSlide &&
        activeSlide.block &&
        activeSlide.block.type === 'triple_column_block'
      "
      v-bind:type="activeSlide.block.type"
      v-bind:data="activeSlide.block.data"
      v-bind:isPlaying="isPlaying"
      v-bind:onClick="onToggle"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
    <VideoSlide
      v-else-if="
        activeSlide &&
        activeSlide.block &&
        activeSlide.block.type === 'video_block'
      "
      v-bind:type="activeSlide.block.type"
      v-bind:data="activeSlide.block.data"
      v-bind:isPlaying="isPlaying"
      v-bind:didReceiveDuration="setSlideDuration"
      v-bind:onClick="onToggle"
      class="transition-opacity-long PrivateViewingSlideSwitch__slide"
    />
  </div>
</template>

<script>
import ImageSlide from "./ImageSlide";
import DoubleImageSlide from "./DoubleImageSlide";
import TripleImageSlide from "./TripleImageSlide";
import MobileImageSlide from "./MobileImageSlide";
import TextSlide from "./TextSlide";
import TitleSlide from "./TitleSlide";
import VideoSlide from "./VideoSlide";

export default {
  name: "PrivateViewingSlideSwitch",
  components: {
    ImageSlide,
    DoubleImageSlide,
    TripleImageSlide,
    MobileImageSlide,
    TextSlide,
    TitleSlide,
    VideoSlide,
  },
  props: {
    activeSlide: {
      id: String,
      index: Number,
      block: {
        id: String,
        type: String,
        data: Object,
      },
    },
    columnNumber: Number,
    privateViewing: Object,
    isLoading: Boolean,
    isPlaying: Boolean,
    isTransitioning: Boolean,
    onToggle: Function,
    setSlideDuration: Function,
    uid: String,
  },
  computed: {
    cssVars() {
      return {
        "--slide-opacity": this.isTransitioning ? 0 : 1,
      };
    },
  },
};
</script>

<style lang="scss">
.PrivateViewingSlideSwitch {
  &__slide {
    opacity: var(--slide-opacity);
  }
}
</style>
